import { createReducer } from 'reduxsauce';
import { SET_SETTINGS } from '../../actions/settings/settingsActions';

const INITIAL_STATE = {
  commentsContext: null,
  socialFeedCommunityId: null,
  socialFeedShowInput: false
};

const setSettings = (state, action) => {
  const {
    commentsContext = state.commentsContext,
    socialFeedCommunityId = state.socialFeedCommunityId,
    socialFeedShowInput = state.socialFeedShowInput
  } = action.payload;
  return {
    ...state,
    commentsContext,
    socialFeedCommunityId,
    socialFeedShowInput
  };
};

export default createReducer(INITIAL_STATE, {
  [SET_SETTINGS]: setSettings
});
